module.exports = __webpack_public_path__ + "img/StrategyIcon.f9561221.svg";